<script>
import MultipleRadios from "@/pages/components/form/input-only/multiple-radios.vue";

export default {
  components: {MultipleRadios},
  inheritAttrs: false,
  emits: ['update:modelValue', 'update:option'],
  props: {
    'modelValue': {
      required: true,
    },
    'name': {
      required: true,
      type: String,
    },
    'label': {
      required: true,
      type: String,
    },
    'extra': {
      required: false,
      type: String,
    },
    'groupClasses': {
      type: String,
      required: false,
    },
    'required': {
      type: Boolean,
      default: true,
    },
    'option' : {
      required: false,
    },
    'options' : {
      type: Array,
      required: false,
    }
  },
}
</script>

<template>
  <div class="form-group row" :class="{[groupClasses] : typeof groupClasses != 'undefined'}">
    <label class="col-xxl-6 col-form-label">{{ label }}</label>
    <label v-if="extra || options" class="col-xxl-6 col-form-label">
      {{ extra }}

      <select @change="this.$emit('update:option', $event.currentTarget.value)" required class="form-control" v-if="options">
        <option :selected="!option" value=""> - Maak een keuze - </option>
        <option v-for="value in options" :selected="value == option" :value="value">{{ value }}</option>
      </select>
    </label>

    <div class="col-xxl-6 ms-auto pt-xxl-7">
      <MultipleRadios
          v-bind="$attrs"
          :name="name"
          :model-value="modelValue"
          :required="required"
          :options="[
            {label: 'OK', value: 'OK'},
            {label: 'Fout', value: 'Fout'},
          ]"
          @update:modelValue="this.$emit('update:modelValue', $event)"
      />
    </div>
  </div>
</template>